import { render, staticRenderFns } from "./PayPage.vue?vue&type=template&id=cedd1b3e&scoped=true"
import script from "./PayPage.vue?vue&type=script&lang=js"
export * from "./PayPage.vue?vue&type=script&lang=js"
import style0 from "./PayPage.vue?vue&type=style&index=0&id=cedd1b3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cedd1b3e",
  null
  
)

export default component.exports